import {ReactNode} from "react";
import NavLink from "./NavLink";
import {useQuery, useQueryClient} from "react-query";
import {useNavigate} from "react-router-dom";

type AppLayoutProps = {
  children: ReactNode;
};

export default function AppLayout({children}: AppLayoutProps) {
  const sidebarLinks = [
    // {
    //   name: "eFTD Africa",
    //   icon: "/menu.png",
    //   link: "/",
    // },
    {
      name: "Dashboard",
      icon: "/dashboard.png",
      link: "/dashboard",
    },
    {
      name: "Orders",
      icon: "/order.png",
      link: "/orders",
    },
    {
      name: "Pickups",
      icon: "/order.png",
      link: "/pickups",
    },
    {
      name: "Deliveries",
      icon: "/order.png",
      link: "/deliveries",
    },
    {
      name: "Customers",
      icon: "/people.svg",
      link: "/customers",
    },
    {
      name: "Subscriptions",
      icon: "/subscribe.png",
      link: "/subscriptions",
    },
    {
      name: "Transactions",
      icon: "/transactionhistory.svg",
      link: "/transactions",
    },
    {
      name: "Admin",
      icon: "/profileicon.png",
      link: "/admin",
    },
    // {
    //   name: "Bikes",
    //   icon: "/bike.png",
    //   link: "/vehicles",
    // },
    // {
    //   name: "Batteries",
    //   icon: "/battery.png",
    //   link: "/batteries",
    // },
    {
      name: "Riders",
      icon: "/rider.png",
      link: "/riders",
    },
    // {
    //   name: "Swap Stations",
    //   icon: "/swapstation.png",
    //   link: "/swapstations",
    // },
    // {
    //   name: "Zones",
    //   icon: "/zone.png",
    //   link: "/pickupzones",
    //   children: [
    //     {
    //       name: "Pickup Zones",
    //       link: "/pickupzones",
    //     },
    //     {
    //       name: "Delivery Zones",
    //       link: "/deliveryzones",
    //     },
    //   ],
    // },
  ];

  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem("eftd-admin-token");
    queryClient.clear();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="p-10">
        <div className="grid grid-cols-12 gap-8">
          {/* Sidebar */}
          <div className="col-span-2">
            <div className="p-6 h-screen fixed">
              <div className="flex flex-col justify-between h-full">
                <div className="">
                  <img className="max-w-[150px] mb-10" src="/eftd-logo.svg" />

                  <nav className="space-y-6">
                    <ul className="space-y-2">
                      {sidebarLinks.map((item) => (
                        <li key={item.link}>
                          <NavLink
                            to={item.link}
                            className="flex items-center space-x-2 text-gray-800 hover:text-black"
                          >
                            <img className="w-5 me-5" src={item.icon} />
                            <span>{item.name}</span>
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                    {/* [logout button] */}
                  </nav>
                </div>

                <button
                  className="block text-black text-gray-800 mb-10"
                  onClick={logout}
                >
                  Logout
                </button>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="col-span-10">
            <div className="p-4 pb-20 w-full rounded-[30px] bg-white overflow-y-scroll h-screen">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
